import { H3, H4, Text } from '@betterment/samba-react';

export const QDIADisclosures: React.FC = () => {
  return (
    <>
      <H3 variant="title200" css={{ pb: 'space.200' }}>
        When do I need these and who should receive them?
      </H3>

      <H4 variant="title100">Participants newly eligible for the plan</H4>

      <Text as="p" css={{ pb: 'space.200' }}>
        When an employee becomes eligible to join your plan, they should be provided certain notices and disclosures.
        These include the QDIA Notice, which explains the default investment strategy that will be used if a participant
        does not provide additional direction, and a fee disclosure (also referred to as a 404(a)(5) notice) describing
        the fees participants can expect to be assessed against their account. These documents should generally be
        provided 30-90 days prior to their entry into the plan or their first contribution is deposited.
      </Text>

      <H4 variant="title100">Annual requirements</H4>

      <Text as="p" css={{ pb: 'space.200' }}>
        For calendar-year plans, participants should receive QDIA notices by December 1st of the preceding year. Fee
        disclosures are required annually within 14 months of the last disclosure, so it is often easiest to provide
        these together by December 1st each year.
      </Text>

      <H4 variant="title100">Changes to disclosures</H4>

      <Text as="p" css={{ pb: 'space.200' }}>
        Betterment will notify you if we post an updated version of the fee disclosure or QDIA Notice. We’ll also let
        you know if the update requires delivery to all participants. Either way, you should update your new participant
        packages to include the newest version.
      </Text>

      <H4 variant="title100">Who should receive the disclosures?</H4>

      <Text as="p" css={{ pb: 'space.300' }}>
        Employees eligible for your plan must receive these disclosures whether or not they are opting to participate at
        this time. Additionally, terminated participants, alternate payees, and beneficiaries with account balances
        should continue to receive these disclosures.
      </Text>

      <Text as="p" variant="text25" color="text.weak">
        Betterment at Work does not provide legal advice. This FAQ is for informational purposes and is not a substitute
        for consultation with legal counsel.
      </Text>
    </>
  );
};
